import { MobileNavbar, Para, Stack } from 'ui-components';
import { Step2 } from './Step2';
import { Step1 } from './Step1';
import { Step3 } from './Step3';
import { Step4 } from './Step4';
import { FormProvider, useForm } from 'react-hook-form';
import { PassBubble } from '../PassBubble';
import { useCheckoutStore } from './checkoutStore';
import { useEffect } from 'react';

type BookFormValues = {
  phone: string;
  name: string;
  existingCustomer: boolean;
  kidCustomer: boolean;
  silentBooking: boolean;
  couponCode: string;
};

export type BookingCheckoutProps = {
  manual: boolean;
  storeSlug?: string;
  hidePassBadge?: boolean;
};

export function BookingCheckout({
  manual = false,
  hidePassBadge = false,
  storeSlug,
}: BookingCheckoutProps): React.ReactElement {
  const defaultValues: BookFormValues = {
    phone: '',
    name: '',
    existingCustomer: false,
    kidCustomer: false,
    silentBooking: false,
    couponCode: '', // legacy, we might remove this in the future to use the new zustand store value
  };

  const formMethods = useForm<BookFormValues>({ defaultValues, mode: 'onChange' });
  const setSelectedStore = useCheckoutStore((state) => state.setSelectedStore);

  // Set the store slug if it is passed in as a prop
  useEffect(() => {
    if (storeSlug) {
      setSelectedStore(storeSlug);
    }
  }, [storeSlug, setSelectedStore]);

  return (
    <FormProvider {...formMethods}>
      <MobileNavbar title="DRYCUT" />

      <Stack gap={10} className="relative">
        {!hidePassBadge && <PassBubble storeSlug={storeSlug} className="-right-14 -top-14" />}

        <Para className="max-w-prose">
          Wir führen eine neue Buchungsmaske ein. Diese soll die Buchung einfacher machen.
          Gleichzeitig kannst Du hier unseren neusten Service “Vorausbuchung” nutzen.
        </Para>

        <Stack gap={6} className="items-start flex-col lg:flex-row h-full gap-10 lg:gap-6">
          <Stack gap={4} className="lg:flex-1 w-full">
            <Step1 storeSlug={storeSlug} />
          </Stack>

          <Stack gap={4} className="lg:flex-1 w-full">
            <Step2 />
          </Stack>

          <Stack gap={4} className="lg:flex-1 w-full">
            <Step3 />
          </Stack>

          <Stack gap={4} className="lg:flex-1 w-full">
            <Step4 />
          </Stack>
        </Stack>
      </Stack>
    </FormProvider>
  );
}
